import { render } from "./equipements.vue?vue&type=template&id=2ca885f2&scoped=true&ts=true"
import script from "./equipements.vue?vue&type=script&lang=ts"
export * from "./equipements.vue?vue&type=script&lang=ts"

import "./equipements.vue?vue&type=style&index=0&id=2ca885f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca885f2"]])

export default __exports__